import React from 'react';

import ErrorMessage from '../components/ErrorMessage';

const Error: React.FC = () => {
	return <ErrorMessage />;
};

export default Error;
